import { useSelector } from 'react-redux';
import { compose } from 'lodash/fp';
import makeFeatureFlagSelector from 'selectors/makeFeatureFlagSelector';

const useFeatureFlag = compose(useSelector, makeFeatureFlagSelector);

export default useFeatureFlag;
